// PostPreview.jsx
import React, { useState } from 'react';
import PostModal from './PostModal';
import './PostPreview.css'; // Import the CSS file

const PostPreview = ({ title, chartTitle, chartSubTitle, source, sourceLink, image }) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const openModal = () => {
      setModalOpen(true);
      console.log('isModalOpen:', isModalOpen);

    };
  
    const closeModal = () => {
      setModalOpen(false);
      console.log('isModalOpen:', isModalOpen);
    };

  return (
    <div className="post-preview" >
        <div  onClick={openModal} className="post-preview-content">
            <img src={image} alt={`${title} Preview`} onClick={openModal}  className="post-image"/>

            <h3>{title}</h3>
            <p>{chartTitle}</p>
        </div>
      { {isModalOpen } && (
        <PostModal
          title={title}
          chartTitle={chartTitle}
          chartSubTitle={chartSubTitle}
          source={source}
          sourceLink={sourceLink}
          image={image}
          onClose={closeModal}
          className={isModalOpen ? 'modal-overlay active' : 'modal-overlay'}
        />
     )}
    </div>
  );
};

export default PostPreview;